import {config} from '../config';
import { handleResponse, buildQuery, addTenant } from '../helpers';

export const catalogService = {
    getSettlements
};

function getSettlements() {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/catalog/settlements-mobility`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}